import {auth, post, url} from "../../../app/services/Backend/HttpRequest"

export default {

  fetchReports({rootState, commit}, payload){

    const input = {
      url: url('auth/report/get'),
      payload,
      headers: auth(rootState)
    }

    return post(input).then(response => commit('fillReports', response.data))
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports/actions.js